import moment from 'moment'
import { createValidationError, required, minLength } from 'labguard-cdk'
import { isDateInPeriod } from 'src/services/period'

const minLength5 = minLength(5)

const isStartDateSameOrAfterEndDate = (startDate, endDate) => {
  if (
    startDate &&
    endDate &&
    moment(startDate)
      .startOf('second')
      .isSameOrAfter(moment(endDate).startOf('second'))
  ) {
    return createValidationError('WEB_NOTE_END_BEFORE_START_ERROR')
  }
}

/**
 * Validate a channel note object
 *
 * @return {Object} An object with the field names which are in error as keys and the corresponding error messages
 * as values. The object will be empty if there is no error.
 */
export const validateNote = ({ content, startDate, endDate }, { period }) => {
  const isStartDateInPeriod = date => {
    if (!isDateInPeriod(period, 'second')(date)) {
      return createValidationError('WEB_NOTE_START_OUT_ERROR')
    }
  }
  const isEndDateInPeriod = date => {
    if (!isDateInPeriod(period, 'second')(date)) {
      return createValidationError('WEB_NOTE_END_OUT_ERROR')
    }
  }

  return {
    content: minLength5(content),
    startDate:
      required(startDate) || isStartDateSameOrAfterEndDate(startDate, endDate) || isStartDateInPeriod(startDate),
    endDate: required(endDate) || isStartDateSameOrAfterEndDate(startDate, endDate) || isEndDateInPeriod(endDate),
  }
}
